'use strict'

import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {
    Box,
    Flex,
    Heading,
    Button,
    Text,
    useStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import {BIRTHDAY_COUPON_CODES, LOYALTYBIRTHDAYBONUS} from '../../../constants'

const BirthdayPromoCard = ({
    onApply,
    isApplying = false,
    calloutHtml,
    showError = false,
    showOrceDownWarning = false
}) => {
    const styles = useStyleConfig('BirthdayPromoCard')
    const {data: basket} = useCurrentBasket()
    const hasOtherPromos = (basket?.couponItems || []).some(
        (item) => !BIRTHDAY_COUPON_CODES.includes(item.code) && item.code !== LOYALTYBIRTHDAYBONUS
    )

    // ChakraUI has a bug where if this SVG is in the theme file
    // It is rendered as `url-gradient(...` instead of `url(....`
    const containerImgUrl =
        "data:image/svg+xml;charset=utf-8,%3Csvg%20width='300'%20height='153'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3E%3Crect%20x='300'%20width='153'%20height='300'%20rx='5'%20transform='rotate(90%20300%200)'%20fill='%23DCF2E1'/%3E%3Cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M278.992%2085.28c-.454%200-.298-.962-2.05-1.072-1.303-.082-2.26-1.03-2.681-2.495.193.013.392.021.599.021%201.63%200%203.098-.684%204.14-1.778a5.702%205.702%200%20004.14%201.778c.207%200%20.405-.008.598-.02-.422%201.463-1.378%202.412-2.682%202.494-1.751.11-1.595%201.073-2.049%201.073h-.015zm-8.2-7.22c-.11-1.752-1.073-1.596-1.073-2.05v-.015c0-.454.963-.298%201.073-2.049.082-1.303%201.032-2.26%202.495-2.681-.012.192-.02.389-.02.594%200%201.63.686%203.099%201.78%204.141a5.703%205.703%200%2000-1.78%204.14c0%20.208.008.407.021.601-1.464-.421-2.414-1.378-2.496-2.681zm6.15-10.268c1.752-.11%201.596-1.073%202.05-1.073h.015c.454%200%20.298.963%202.049%201.073%201.305.082%202.263%201.033%202.684%202.5a9.004%209.004%200%2000-.6-.02c-1.63%200-3.098.684-4.14%201.778a5.702%205.702%200%2000-4.14-1.779c-.208%200-.407.008-.601.021.421-1.466%201.378-2.418%202.683-2.5zm1.27%209.73c.255.035.514.06.778.06h.018c.266%200%20.525-.025.78-.06a5.16%205.16%200%2001-.788%201.43%205.16%205.16%200%2001-.788-1.43zm-.736-2.307a5.714%205.714%200%2000-.059.779v.018c0%20.263.023.52.058.773a5.149%205.149%200%2001-1.423-.785%205.167%205.167%200%20011.424-.785zm2.31-.738a5.762%205.762%200%2000-.778-.059h-.018c-.264%200-.521.024-.776.06.182-.512.451-.992.786-1.424.335.432.604.912.786%201.423zm.797%201.535v-.018c0-.265-.024-.523-.059-.778.511.181.991.45%201.423.784a5.15%205.15%200%2001-1.422.784c.035-.253.058-.51.058-.772zm-1.569%201.042H278.985a4.39%204.39%200%2001-.938-.103%204.35%204.35%200%2001-.103-.933v-.03c0-.318.037-.632.104-.94.306-.066.619-.102.937-.102H279.014c.318%200%20.632.036.939.103a4.4%204.4%200%2001.103.939v.03c0%20.316-.036.628-.103.933a4.4%204.4%200%2001-.939.103zm3.894-6.029c.35%200%20.683.025%201%20.07.045.317.07.648.07.996%200%201.31-.604%202.561-1.535%203.48a5.687%205.687%200%2000-2.039-.974%205.675%205.675%200%2000-.975-2.039c.919-.93%202.169-1.533%203.479-1.533zm-7.816%200c1.31%200%202.56.603%203.479%201.533a5.674%205.674%200%2000-.975%202.039c-.75.188-1.44.523-2.04.974-.931-.919-1.535-2.17-1.535-3.48%200-.348.025-.68.069-.996.319-.044.652-.07%201.002-.07zm0%209.956c-.35%200-.683-.026-1.001-.07a7.291%207.291%200%2001-.07-1.002c0-1.31.604-2.561%201.535-3.48a5.692%205.692%200%20002.038.974c.188.752.524%201.444.977%202.045-.919.93-2.169%201.533-3.479%201.533zm7.816%200c-1.31%200-2.56-.603-3.479-1.533a5.684%205.684%200%2000.977-2.045%205.691%205.691%200%20002.037-.974c.931.919%201.535%202.17%201.535%203.48%200%20.35-.026.683-.071%201.002a7.16%207.16%200%2001-.999.07zm4.3-7.035c.11%201.751%201.073%201.595%201.073%202.05v.014c0%20.455-.963.299-1.073%202.05-.082%201.303-1.032%202.26-2.497%202.682.013-.194.021-.393.021-.601%200-1.63-.686-3.099-1.78-4.14a5.703%205.703%200%20001.78-4.142c0-.205-.008-.402-.021-.594%201.465.42%202.415%201.378%202.497%202.681zm-5.752%2011.63c1.571-.757%202.769-1.92%203.148-3.969%202.05-.378%203.215-1.577%203.973-3.148.928-1.924%201.423-1.903%201.423-2.456%200-.553-.495-.533-1.423-2.457-.758-1.57-1.923-2.769-3.972-3.147-.378-2.052-1.577-3.218-3.149-3.976-1.924-.928-1.904-1.423-2.457-1.423-.553%200-.532.495-2.456%201.423-1.573.758-2.772%201.924-3.149%203.976-2.049.379-3.213%201.577-3.971%203.147-.928%201.924-1.423%201.904-1.423%202.457%200%20.553.495.532%201.423%202.456.758%201.571%201.923%202.77%203.972%203.148.379%202.048%201.577%203.212%203.148%203.97%201.924.928%201.903%201.423%202.456%201.423.553%200%20.533-.495%202.457-1.423z'%20fill='%23287037'/%3E%3C/svg%3E"
    const containerInnerImgUrl =
        "data:image/svg+xml;charset=utf-8,%3Csvg width='270' height='153' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='a' fill='%23fff'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M270 5a5 5 0 00-5-5H5a5 5 0 00-5 5v143a5 5 0 005 5h260a5 5 0 005-5v-47.142c0-1.652-.836-3.172-2.104-4.23C261.848 91.583 258 83.99 258 75.5s3.848-16.083 9.896-21.128c1.268-1.057 2.104-2.578 2.104-4.23V5z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M270 5a5 5 0 00-5-5H5a5 5 0 00-5 5v143a5 5 0 005 5h260a5 5 0 005-5v-47.142c0-1.652-.836-3.172-2.104-4.23C261.848 91.583 258 83.99 258 75.5s3.848-16.083 9.896-21.128c1.268-1.057 2.104-2.578 2.104-4.23V5z' fill='%23F9F8F7'/%3E%3Cpath d='M267.896 54.372l.32.384-.32-.384zm0 42.256l.32-.384-.32.384zM5 .5h260v-1H5v1zM.5 148V5h-1v143h1zm264.5 4.5H5v1h260v-1zm4.5-51.642V148h1v-47.142h-1zm-1.284-4.614C262.278 91.29 258.5 83.837 258.5 75.5h-1c0 8.646 3.919 16.376 10.076 21.512l.64-.768zM258.5 75.5c0-8.337 3.778-15.79 9.716-20.744l-.64-.768C261.419 59.124 257.5 66.854 257.5 75.5h1zm11-70.5v45.142h1V5h-1zm-1.284 49.756c1.362-1.136 2.284-2.79 2.284-4.614h-1c0 1.479-.75 2.866-1.924 3.846l.64.768zm2.284 46.102c0-1.825-.922-3.479-2.284-4.614l-.64.768c1.174.98 1.924 2.367 1.924 3.846h1zM265 153.5a5.5 5.5 0 005.5-5.5h-1a4.5 4.5 0 01-4.5 4.5v1zM-.5 148a5.5 5.5 0 005.5 5.5v-1A4.5 4.5 0 01.5 148h-1zM265 .5a4.5 4.5 0 014.5 4.5h1A5.5 5.5 0 00265-.5v1zM5-.5A5.5 5.5 0 00-.5 5h1A4.5 4.5 0 015 .5v-1z' fill='%23F3F0ED' mask='url(%23a)'/%3E%3C/svg%3E"
    const backgroundImageAsStyle = `url("${containerImgUrl}")`
    const backgroundImageAsStyle2 = `url("${containerInnerImgUrl}")`
    const overlayContainerStyles = {
        backgroundImage: backgroundImageAsStyle,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100%',
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: '0',
        left: 0,
        top: 0
    }

    const innerContainerStyles = {
        backgroundImage: backgroundImageAsStyle2,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100%',
        zIndex: '0',
        position: 'absolute',
        height: '100%',
        width: '270px',
        padding: '20px'
    }
    return (
        <Box data-testid="birthday-promo-card" {...styles.container}>
            <Box className="birthday-promo-card-background" style={overlayContainerStyles}></Box>
            <Box className="birthday-promo-card-inner" style={innerContainerStyles}>
                <Heading {...styles.heading}>
                    <FormattedMessage defaultMessage="Happy Birthday!" id="birthday_promo.title" />
                </Heading>
                {calloutHtml && (
                    <Box
                        className="birthday-promo-callout"
                        dangerouslySetInnerHTML={{__html: calloutHtml}}
                        {...styles.calloutMessage}
                    />
                )}
                <Flex alignItems="center">
                    {!showOrceDownWarning && (
                        <Button
                            type="button"
                            className="redeem-birthday-offer"
                            onClick={() => {
                                if (!hasOtherPromos) onApply()
                            }}
                            disabled={isApplying || hasOtherPromos}
                            {...styles.button}
                        >
                            <FormattedMessage
                                defaultMessage="Redeem Birthday Offer"
                                id="birthday_promo.apply"
                            />
                        </Button>
                    )}
                    {showError && (
                        <Text {...styles.errorText}>
                            <FormattedMessage
                                defaultMessage="Cannot apply offer."
                                id="birthday_promo.cannot_apply"
                            />
                        </Text>
                    )}
                </Flex>
            </Box>
        </Box>
    )
}

BirthdayPromoCard.propTypes = {
    onApply: PropTypes.func.isRequired,
    isApplying: PropTypes.bool,
    calloutHtml: PropTypes.string,
    showOrceDownWarning: PropTypes.bool,
    showError: PropTypes.bool
}

export default BirthdayPromoCard
